import { useApi } from './useApi'

const BASE_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

export const useEstudioDashboardTokens = () => {
  const api = useApi()

  const getPublicUrl = (token) =>
    `${window.location.origin}/estudios-dashboard-publico?token=${token}`

  const getPublicUrlAsignacion = (token) =>
    `${window.location.origin}/estudio-asignacion?token=${token}`

  const getTokens = () => api.get('/api/estudios/tokens')

  const createToken = (name = 'Enlace') =>
    api.post('/api/estudios/tokens', { name })

  const revokeToken = (token) => api.del(`/api/estudios/tokens/${token}`)

  const addEstudioToToken = (token, estudioId) =>
    api.post(`/api/estudios/tokens/${token}/estudios/${estudioId}`, {})

  const removeEstudioFromToken = (token, estudioId) =>
    api.del(`/api/estudios/tokens/${token}/estudios/${estudioId}`)

  const fetchPublicEstudiosDashboard = async (token) => {
    const res = await fetch(`${BASE_URL}/api/public/estudios-dashboard/${token}`)
    return res.json()
  }

  // payload + archivos (File[]) se envían como multipart/form-data, mismo patrón
  // que useEstudios().updatePublicEstudio.
  const toFormData = (payload, files) => {
    const fd = new FormData()
    for (const [key, value] of Object.entries(payload)) {
      if (value !== null && value !== undefined) fd.append(key, value)
    }
    for (const file of files || []) fd.append('archivos', file)
    return fd
  }

  const updatePublicEstudioDashboard = async (token, id, payload, files) => {
    const res = await fetch(`${BASE_URL}/api/public/estudios-dashboard/${token}/${id}`, {
      method: 'PUT',
      body: toFormData(payload, files),
    })
    return res.json()
  }

  const deletePublicEstudioDashboardAdjunto = async (token, id, adjuntoId) => {
    const res = await fetch(`${BASE_URL}/api/public/estudios-dashboard/${token}/${id}/adjuntos/${adjuntoId}`, {
      method: 'DELETE',
    })
    return res.json()
  }

  // Enlace individual del estudio, para compartir con quien lo va a atender.
  const fetchEstudioAsignacionLink = async (token, id) => {
    const res = await fetch(`${BASE_URL}/api/public/estudios-dashboard/${token}/${id}/asignacion-link`)
    return res.json()
  }

  const createEstudioAsignacionLink = async (token, id) => {
    const res = await fetch(`${BASE_URL}/api/public/estudios-dashboard/${token}/${id}/asignacion-link`, {
      method: 'POST',
    })
    return res.json()
  }

  // Lista de voluntarios (nombre + whatsapp) para asignar estudios desde el dashboard público.
  const fetchPublicVoluntarios = async (token) => {
    const res = await fetch(`${BASE_URL}/api/public/estudios-dashboard/${token}/voluntarios`)
    return res.json()
  }

  const createPublicVoluntario = async (token, payload) => {
    const res = await fetch(`${BASE_URL}/api/public/estudios-dashboard/${token}/voluntarios`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    return res.json()
  }

  const updatePublicVoluntario = async (token, id, payload) => {
    const res = await fetch(`${BASE_URL}/api/public/estudios-dashboard/${token}/voluntarios/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    return res.json()
  }

  const deletePublicVoluntario = async (token, id) => {
    const res = await fetch(`${BASE_URL}/api/public/estudios-dashboard/${token}/voluntarios/${id}`, {
      method: 'DELETE',
    })
    return res.json()
  }

  return {
    getPublicUrl,
    getPublicUrlAsignacion,
    getTokens,
    createToken,
    revokeToken,
    addEstudioToToken,
    removeEstudioFromToken,
    fetchPublicEstudiosDashboard,
    updatePublicEstudioDashboard,
    deletePublicEstudioDashboardAdjunto,
    fetchEstudioAsignacionLink,
    createEstudioAsignacionLink,
    fetchPublicVoluntarios,
    createPublicVoluntario,
    updatePublicVoluntario,
    deletePublicVoluntario,
  }
}
